import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronRight, Home } from 'lucide-react';

export const Breadcrumbs = ({ items }) => {
  return (
    <nav className="flex items-center gap-2 text-sm text-gray-500 mb-6" aria-label="Breadcrumb" data-testid="breadcrumbs">
      <Link to="/" className="hover:text-[#003B73] transition-colors flex items-center gap-1">
        <Home className="h-4 w-4" />
        <span className="hidden sm:inline">Hem</span>
      </Link>
      {items.map((item, index) => (
        <React.Fragment key={index}>
          <ChevronRight className="h-4 w-4 text-gray-400" />
          {item.href ? (
            <Link to={item.href} className="hover:text-[#003B73] transition-colors">
              {item.label}
            </Link>
          ) : (
            <span className="text-[#0F172A] font-medium">{item.label}</span>
          )}
        </React.Fragment>
      ))}
    </nav>
  );
};
